import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent {

  @Output() toggle: EventEmitter<any> = new EventEmitter();
  isAuthenticated: boolean = false;
  public userName:string | undefined;
  constructor(private route: Router, public oktaAuth: OktaAuthService ) { 

  }

  ngOnInit() {
    this.oktaAuth.$isAuthenticated.subscribe(val => {
      this.isAuthenticated = val;
      if(val)
      this.oktaAuth.getUser().then(usr=> {
        this.userName = usr ? usr : "";
        localStorage.setItem("loggedName",this.userName);
      });
    });
  }

  emit() {
    this.toggle.emit(null);
  }

  public handleLogout() {
    localStorage.clear();
    this.oktaAuth.revokeAccessToken();
    this.route.navigate(['/logout']);
  }
}
